// // eslint-disable-next-line import/prefer-default-export
import loadable from '@loadable/component'

export const OutlookPopup = loadable(() => import('./OutlookPopup'))
export const OutlookKey = loadable(() => import('./OutlookKey'))
